export const picklistTemplateDefaultValues = {};
